import { render, staticRenderFns } from "./MarketingEmailCreateModel.vue?vue&type=template&id=dea719aa&scoped=true"
import script from "./MarketingEmailCreateModel.vue?vue&type=script&lang=js"
export * from "./MarketingEmailCreateModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea719aa",
  null
  
)

export default component.exports